import { BlogSection } from '@/types/blog';

export const ansatzSection: BlogSection = {
  id: 'ansatz',
  title: 'Der Weg zum Selbstentscheider: Fokus Hochsensibilität',
  content: `
    <p>
      Mein Ziel ist es, dass Sie am Ende des Prozesses weniger auf externe Experten angewiesen sind 
      als zuvor. Die Forschung zur <strong>Selbstbestimmungstheorie</strong> (Deci & Ryan) zeigt, dass 
      Menschen Verhalten nur dann nachhaltig ändern, wenn sie es aus eigenem Antrieb tun. Mein Coaching 
      richtet sich an alle Menschen, die finanzielle Klarheit suchen – auch und gerade an jene mit 
      besonderen Denkstrukturen:
    </p>

    <p>
      <strong>Hochsensible Entscheider:</strong> Sie nehmen Risiken und Nuancen intensiver wahr. Als 
      Coach unterstütze ich Sie dabei, diese feine Wahrnehmung nicht als Bremse, sondern als Kompass 
      für fundierte Entscheidungen zu nutzen.
    </p>

    <p>
      <strong>Scanner-Persönlichkeiten:</strong> Für vielseitig interessierte Menschen wirkt das 
      klassische „Buy and Hold" oft zu starr. Wir entwickeln flexible Ansätze, die Abwechslung und 
      Sicherheit vereinen.
    </p>

    <p>
      Durch die Verbindung meiner Fachwirt-Expertise mit Erkenntnissen der <strong>Behavioral Finance</strong> 
      schaffen wir Strategien, die zu Ihrem Wesen passen.
    </p>
  `
};
